import moment from "moment";
import React, { useEffect, useState } from "react";
import { Card, CardBody } from "reactstrap";
import {
  getMonthsOfEvaluation,
  getEvaluationsOnFeed,
} from "../../../actions/feedActions";
import { daysName, monthNames } from "../../../actions/utility";

const EvaluationComponent = (props) => {
  const { programs, studentId } = props;

  const [months, setmonths] = useState([]);
  const [programName, setprogramName] = useState("");
  const [monthName, setmonthName] = useState("");
  const [evaluationAvgData, setevaluationAvgData] = useState("");
  const [evaluationsData, setevaluationsData] = useState([]);
  const [loading, setloading] = useState(true);
  const [monthData, setmonthData] = useState([
    {
      monthName: "January",
      id: "01",
    },
    {
      monthName: "February",
      id: "02",
    },
    {
      monthName: "March",
      id: "03",
    },
    {
      monthName: "April",
      id: "04",
    },
    {
      monthName: "May",
      id: "05",
    },
    {
      monthName: "June",
      id: "06",
    },
    {
      monthName: "July",
      id: "07",
    },
    {
      monthName: "August",
      id: "08",
    },
    {
      monthName: "September",
      id: "09",
    },
    {
      monthName: "October",
      id: "10",
    },
    {
      monthName: "November",
      id: "11",
    },
    {
      monthName: "December",
      id: "12",
    },
  ]);
  useEffect(() => {
    // getMonthsOfEvaluation(studentId, 2)
    //     .then((res) => {
    //         setmonths(res.data.evaluationMonths);
    //     })
    //     .catch((err) => {
    //         debugger;
    //     })
  }, []);

  const onChangeProgram = (e) => {
    setmonthName("");
    setloading(true);
    setevaluationAvgData("");
    setevaluationsData([]);
    getMonthsOfEvaluation(studentId, 2, e.target.value)
      .then((res) => {
        setmonths(res.data.evaluationMonths);
      })
      .catch((err) => {
        debugger;
      });
    setprogramName(e.target.value);
  };
  const onChangeMonth = (e) => {
    setmonthName(e.target.value);
    if (e.target.value != "all") {
      var filterMonth = monthData.filter(
        (item) => item.monthName == e.target.value
      );
      getEvaluationsOnFeed(studentId, 2, programName, filterMonth[0]["id"])
        .then((res) => {
          setevaluationAvgData(res.data.evaluationAvgData);
          setevaluationsData(res.data.evaluations);
          setloading(false);
        })
        .catch((error) => {
          debugger;
        });
    } else {
      getEvaluationsOnFeed(studentId, 2, programName, "all")
        .then((res) => {
          setevaluationAvgData(res.data.evaluationAvgData);
          setevaluationsData(res.data.evaluations);
          setloading(false);
        })
        .catch((error) => {
          debugger;
        });
    }
  };

  const getEveluationDate = (evaluationDate) => {
    const newDate = new Date(evaluationDate);

    if (
      typeof newDate === "object" &&
      typeof newDate.getFullYear === "function" &&
      typeof newDate.getFullYear().toString() === "string"
    ) {
      var year = newDate.getFullYear().toString().substr(-2);
      return (
        <label>
          {/* {daysName[newDate.getDay() - 1].slice(0, 3)} {newDate.getDate()} {monthNames[newDate.getMonth()].slice(0, 3)} '{year} */}
          {moment(evaluationDate).format("ll")}
        </label>
      );
    } else {
      return <label>Day - Date - Month - Year</label>;
    }
  };

  console.log("Avg Data", evaluationAvgData);
  console.log("Evaluation Data", evaluationsData);
  return (
    <Card
      style={{
        marginBottom: "2vh",
        border: "1px #ccc solid",
        textAlign: "left",
      }}
    >
      <CardBody>
        <div className="EvaluationSection">
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <h5 className="evaluationheading">Evaluation for:</h5>
            </div>
            <div className="col-6">
              <label>Select Class: </label>
              <br />
              <select
                className="form-select"
                aria-label=".form-select-sm example"
                name="year"
                onChange={(e) => onChangeProgram(e)}
              >
                <option selected>Enrolled Classes</option>
                {programs.map((item, index) => (
                  <option key={index} value={item.progid}>
                    {item.prog_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-6">
              <label>Select Month: </label>
              <br />
              <select
                className="form-select"
                aria-label=".form-select-sm example"
                name="month"
                onChange={onChangeMonth}
                value={monthName}
              >
                <option>Months</option>
                {months.length > 0 ? <option value="all">All</option> : null}
                {months.map((item, index) => (
                  <option key={index} value={item.month}>
                    {item.month}
                  </option>
                ))}
              </select>
            </div>
            {!loading ? (
              <div className="col-md-12 mt-4">
                <div className="table-responsive">
                  <table className="table text-center table-sm">
                    <tr className="tableHeaderP">
                      <th className="text-left">
                        <label>Evaluation Date</label>
                      </th>
                      <td className="">
                        <div className="">
                          <label> On Time </label>
                          <div className="d-flex totalEvaluate">
                            <div className="smileColor">
                              {" "}
                              <i className="far fa-grin"></i> <br />{" "}
                              <label>
                                {" "}
                                {evaluationAvgData["onTimeAvg"]}
                                <span>%</span>
                              </label>{" "}
                            </div>
                            <div className="sadColor">
                              {" "}
                              <i className="far fa-meh"></i> <br />{" "}
                              <label>
                                {" "}
                                {evaluationAvgData["notOnTimeAvg"]}
                                <span>%</span>
                              </label>{" "}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="">
                        <div className="">
                          <label> Attentive </label>
                          <div className="d-flex totalEvaluate">
                            <div className="smileColor">
                              {" "}
                              <i className="far fa-grin"></i> <br />{" "}
                              <label>
                                {" "}
                                {evaluationAvgData["attentiveAvg"]}
                                <span>%</span>
                              </label>{" "}
                            </div>
                            <div className="sadColor">
                              {" "}
                              <i className="far fa-meh"></i> <br />{" "}
                              <label>
                                {" "}
                                {evaluationAvgData["notAttentiveAvg"]}
                                <span>%</span>
                              </label>{" "}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="">
                        <div className="">
                          <label> Homework </label>
                          <div className="d-flex totalEvaluate">
                            <div className="smileColor">
                              {" "}
                              <i className="far fa-grin"></i> <br />{" "}
                              <label>
                                {" "}
                                {evaluationAvgData["homeworkCompletionAvg"]}
                                <span>%</span>
                              </label>{" "}
                            </div>
                            <div className="sadColor">
                              {" "}
                              <i className="far fa-meh"></i> <br />{" "}
                              <label>
                                {" "}
                                {evaluationAvgData["homeworkNotCompletionAvg"]}
                                <span>%</span>
                              </label>{" "}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="">
                        <div className="">
                          <label> Classwork </label>
                          <div className="d-flex totalEvaluate">
                            <div className="smileColor">
                              {" "}
                              <i className="far fa-grin"></i> <br />{" "}
                              <label>
                                {" "}
                                {evaluationAvgData["classworkCompletionAvg"]}
                                <span>%</span>
                              </label>{" "}
                            </div>
                            <div className="sadColor">
                              {" "}
                              <i className="far fa-meh"></i> <br />{" "}
                              <label>
                                {" "}
                                {evaluationAvgData["classworkNotCompletionAvg"]}
                                <span>%</span>
                              </label>{" "}
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tbody>
                      {evaluationsData.map((item, index) =>
                        item.attendance_data !== null ? (
                          <tr key={index}>
                            <th className="text-left">
                              <label className="evaluationDate">
                                {getEveluationDate(item.attendance_ts)}
                              </label>
                            </th>
                            <td>
                              <div className="iconsCss">
                                <label>
                                  {" "}
                                  {JSON.parse(item.attendance_data)[
                                    "onTime"
                                  ] === 1 ? (
                                    <i className="far fa-grin smileSelect"></i>
                                  ) : JSON.parse(item.attendance_data)[
                                      "onTime"
                                    ] === 0 ? (
                                    <i className="far fa-meh sadSelect"></i>
                                  ) : (
                                    "--"
                                  )}
                                </label>{" "}
                                {/* <label>
                                  {" "}
                                  <i
                                    className={
                                      JSON.parse(item.attendance_data)[
                                        "onTime"
                                      ] === 0
                                        ? "far fa-meh sadSelect"
                                        : "-"
                                    }
                                  ></i>
                                </label> */}
                              </div>
                            </td>
                            <td>
                              <div className="iconsCss">
                                <label>
                                  {" "}
                                  {JSON.parse(item.attendance_data)[
                                    "attentive"
                                  ] === 1 ? (
                                    <i className="far fa-grin smileSelect"></i>
                                  ) : JSON.parse(item.attendance_data)[
                                      "attentive"
                                    ] === 0 ? (
                                    <i className="far fa-meh sadSelect"></i>
                                  ) : (
                                    "--"
                                  )}
                                </label>{" "}
                                {/* <label>
                                  {" "}
                                  <i
                                    className={
                                      JSON.parse(item.attendance_data)[
                                        "attentive"
                                      ] === 0
                                        ? "far fa-meh sadSelect"
                                        : "far fa-meh"
                                    }
                                  ></i>
                                </label> */}
                              </div>
                            </td>
                            <td>
                              <div className="iconsCss">
                                <label>
                                  {" "}
                                  {JSON.parse(item.attendance_data)[
                                    "homeworkCompletion"
                                  ] === 1 ? (
                                    <i className="far fa-grin smileSelect"></i>
                                  ) : JSON.parse(item.attendance_data)[
                                      "homeworkCompletion"
                                    ] === 0 ? (
                                    <i className="far fa-meh sadSelect"></i>
                                  ) : (
                                    "--"
                                  )}
                                </label>{" "}
                                {/* <label>
                                  {" "}
                                  <i
                                    className={
                                      JSON.parse(item.attendance_data)[
                                        "homeworkCompletion"
                                      ] === 0
                                        ? "far fa-meh sadSelect"
                                        : "far fa-meh"
                                    }
                                  ></i>
                                </label> */}
                              </div>
                            </td>
                            <td>
                              <div className="iconsCss">
                                <label>
                                  {" "}
                                  {JSON.parse(item.attendance_data)[
                                    "classworkCompletion"
                                  ] === 1 ? (
                                    <i className="far fa-grin smileSelect"></i>
                                  ) : JSON.parse(item.attendance_data)[
                                      "classworkCompletion"
                                    ] === 0 ? (
                                    <i className="far fa-meh sadSelect"></i>
                                  ) : (
                                    "--"
                                  )}
                                </label>{" "}
                                {/* <label>
                                  {" "}
                                  <i
                                    className={
                                      JSON.parse(item.attendance_data)[
                                        "classworkCompletion"
                                      ] === 0
                                        ? "far fa-meh sadSelect"
                                        : "far fa-meh"
                                    }
                                  ></i>
                                </label> */}
                              </div>
                            </td>
                          </tr>
                        ) : null
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="col-md-12 mt-4 text-center">
                {/* <label className="text-primary font-weight-bold">No Data</label> */}
                <p className="text-muted p-5" style={{ fontSize: 14 }}>
                  Please select <strong>Class</strong> and{" "}
                  <strong>Month</strong> from the dropdown
                </p>
              </div>
            )}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default EvaluationComponent;
